<template>
    <div class="tile tile-secondary" v-if="integration">
        <div class="tile-title">
            <h2>{{integration.displayLabel}}</h2>
            <div class="avatar no-flex">
                <div class="avatar-image" v-fs-block>
                    <figure class="image image-avatar">
                        <img :alt="integration.displayLabel" :src="integration.logoSrc"/>
                    </figure>
                </div>
            </div>
        </div>
        <div class="tile-content">
            <p class="text-muted stack-l">
                {{integration.description}}
            </p>
            <p class="text-muted stack-l" v-if="integration.documentationUrl">
                Questions? Read more about the {{integration.displayLabel}} integrations in our
                <r-button type="link">documentation</r-button>.
            </p>
        </div>
    </div>
    <div class="tile tile-secondary" v-else>
        <div class="tile-content">
            <div class="display-flex">
                <v-icon class="inline-s" icon="help"/>
                <div>
                    <p class="text-muted">Connect your data with other applications that you use.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        vIcon,
    } from '@/components/form';
    import IntegrationsModel from '@/common/models/integration-model';

    export default {
        components: {
            vIcon,
        },
        props: {
            integration: {
                type: IntegrationsModel,
            },
        },
    };
</script>
